import { render, staticRenderFns } from "./subMenuItem.vue?vue&type=template&id=2e24b338&scoped=true&"
import script from "./subMenuItem.vue?vue&type=script&lang=js&"
export * from "./subMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./subMenuItem.vue?vue&type=style&index=0&id=2e24b338&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e24b338",
  null
  
)

export default component.exports